import { IAppStore } from '@models/store.model'
import { Button, InputLabel, Typography } from '@mui/material'
import { webApiService } from '@services/index'
// import { useSnackbar } from 'notistack'
import { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useSelector } from 'react-redux'

import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

const MassDeliveryPage = () => {
  const [data, setData] = useState<{loading: boolean, html: string, userList: any[], id_assigned_technician: number}>({ loading: false, html: '', userList: [], id_assigned_technician: 0 })
  const [otList, setOtList] = useState<any[]>([])
  const userState = useSelector((store: IAppStore) => store.user)

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const validFiles = acceptedFiles.filter(file =>
      ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type)
    )
    console.log('🚀 ~ onDrop ~ validFiles:', validFiles)

    if (!validFiles.length) return

    const reader = new FileReader()
    reader.onload = async (e) => {
      const arrayBuffer = e.target?.result
      if (!arrayBuffer) return

      const workbook = new ExcelJS.Workbook()
      await workbook.xlsx.load(arrayBuffer as ArrayBuffer)

      const worksheet = workbook.worksheets[0] // toma la primera hoja
      const rows: any[] = []

      worksheet.eachRow((row, rowNumber) => {
      // Si la primera fila contiene encabezados
        if (rowNumber === 1) return

        const rowData: any = {}
        row.eachCell((cell, colNumber) => {
          const header = worksheet.getRow(1).getCell(colNumber).value
          rowData[header as string] = cell.value
        })
        rows.push(rowData)
      })

      setOtList(rows)
      console.log('🚀 ~ ExcelJS parsed rows:', rows)
    }

    reader.readAsArrayBuffer(validFiles[0])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
    maxFiles: 1,
    maxSize: (process.env.VITE_MAXFILESIZE !== undefined) ? parseInt(process.env.VITE_MAXFILESIZE) : 2097152,
    accept: {
      'application/vnd.ms-excel': ['.xlsx'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onDrop
  })

  const entregarInsumos = async () => {
    setData({ ...data, loading: true })
    let html = '----- INICIO -----<br/>'
    console.log('🚀 ~ asignarTecnico ~ otList:', otList)
    for (const item of otList) {
      const objDelivery = {
        ot: item.ot,
        updated_by: userState.id
      }
      console.log('🚀 ~ entregarInsumos ~ objDelivery:', objDelivery)

      // eslint-disable-next-line no-loop-func
      await webApiService.deliverySupply(objDelivery).then((res) => {
        console.log('🚀 ~ awaitwebApiService.AssignTech ~ res:', res)
        html += '<p>' + item.ot + ' - ' + res.data + '</p>'
        // eslint-disable-next-line no-loop-func
      }).catch((err) => {
        console.log('🚀 ~ awaitwebApiService.sendMails ~ err:', err)
        html += '<p>' + item.ot + ' - ' + err.response.data.message + '</p>'
      })
      setData({ ...data, html, loading: true })
    }
    html += '----- FIN -----<br/>'
    setData({ ...data, loading: false, html })
  }

  return (
    <div className='container-xxl '>
      <div className='row gy-3 my-4'>
        <div className='col-12 my-2'>
          <Typography variant='h6' className='title mb-3'>
            Entrega de insumos por OT
          </Typography>
          <div className='shadow-sm rounded bg-white p-3'>
            <div className='text-end'>
              <Button
                variant='contained'
                size='medium'
                color='primary'
                className='m-2'
                onClick={async (e: any) => {
                  const workbook = new ExcelJS.Workbook()
                  const sheet = workbook.addWorksheet('Plantilla')
                  const header = ['ot']
                  sheet.addRows([header])

                  const buffer = await workbook.xlsx.writeBuffer()
                  saveAs(new Blob([buffer]), 'Plantilla.xlsx')
                }}
              >
                Descargar Plantilla
              </Button>
            </div>
            <InputLabel id='demo-simple-select-label'>Excel con listado de ordenes para realizar entrega de insumos:</InputLabel>
            <div hidden={otList.length > 0} {...getRootProps({ className: isDragAccept ? 'p-5 dropzone dropzone-accept' : isDragReject ? 'p-5 dropzone dropzone-reject' : 'p-5 dropzone' })}>
              <input {...getInputProps()} />
              <div className='alert alert-danger text-center p-3' role='alert'>
                <p>El archivo que esta intentando adjuntar no esta permitido</p>
                <hr />
                <p className='mb-0 small'>* Archivos permitido es: <strong>XLSX</strong></p>
              </div>
              <div className='text-center instrucciones'>

                <Button
                  variant='contained'
                  size='medium'
                  color='secondary'
                  className='m-2'
                >
                  Seleccione archivos
                </Button>
                <p className='mt-3 mb-0'><strong>Haga click para subir el archivo</strong> o arrastre y suelte aquí.</p>
                <p>XLSX (tamaño máximo 2 mb)</p>
              </div>
            </div>
            {otList.map((item: any, idx: number) => {
              return (<span key={idx} className='badge rounded-pill text-bg-secondary me-1'>{item.ot}</span>)
            })}
            <div hidden={otList.length === 0}>
              <Button size='small' onClick={() => { setOtList([]) }}> Cargar excel nuevamente</Button>
            </div>
            <div className='text-end'>
              <Button
                variant='contained'
                color='primary'
                className='mt-2'
                onClick={() => { entregarInsumos() }}
                disabled={otList.length === 0 || data.id_assigned_technician === 0 || data.loading}
              >
                ENTREGAR INSUMOS
              </Button>
            </div>
            <div className={data.html === '' ? 'bg-black p-0 text-white mt-2' : 'bg-black p-2 text-white mt-2'} dangerouslySetInnerHTML={{ __html: data.html }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MassDeliveryPage
